import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getWithdrawTransactions} from '../../../apis/withdraw/withdrawTransactions'

const useQueryWithdrawTransaction = (id?: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getWithdrawTransaction(id),
        queryFn: async () => {
            const {data} = await getWithdrawTransactions(id)
            return {data}
        },
    })

    return {data, refetch}
}

export default useQueryWithdrawTransaction
